import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center overflow-hidden rounded-b-[24px] md:rounded-b-[32px] mx-2 md:mx-4 lg:mx-6">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20cityscape%20with%20spotlights%20and%20camera%20flashes%2C%20blurred%20celebrity%20silhouettes%2C%20neon%20signs%2C%20warm%20amber%20and%20orange%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20entertainment%20industry%20theme%2C%20editorial%20photography%20style&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="91吃瓜网"
          className="w-full h-full object-cover"
          width="1600"
          height="900"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-8 max-w-4xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-6 backdrop-blur-sm">
          每日更新 · 独家爆料 · 真实可信
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6">
          91吃瓜网
        </h1>
        <p className="text-base md:text-lg lg:text-xl text-white/80 font-light max-w-2xl mx-auto mb-8 leading-relaxed">
          最新91吃瓜爆料视频在线观看，黑料吃瓜网站每日更新不间断，精准承接热门搜索，为您提供最流畅的吃瓜体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/entertainment"
            className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            浏览热门爆料
          </Link>
          <Link
            to="/category/exclusive"
            className="bg-white/15 backdrop-blur-sm text-white border border-white/30 px-8 py-3 rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            查看独家内容
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center pt-2">
          <div className="w-1.5 h-1.5 bg-white/70 rounded-full" />
        </div>
      </div>
    </section>
  );
}